export default __webpack_public_path__ + "static/media/desktop_about_cover.309993c1.jpeg";